import { DeliveryReport } from "types";
import { useInfiniteCollection } from "@/hooks/useInfiniteCollection";
import { buildDeliveryReportParams, DeliveryReportFilters } from "@/models/DeliveryReport";
import { getSeller } from "@/utils/getSeller";

export const useDeliveryReports = (filters: DeliveryReportFilters) => {
    const seller = getSeller();
    const params = buildDeliveryReportParams(filters, seller.id);

    const response = useInfiniteCollection<DeliveryReport>("deliveryReports", params, {
        staleTime: 0,
        refetchOnMount: "always",
    });

    return { ...response, deliveryReports: response.data };
};
